import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import ExpiredSubscriptionTable from "./ExpiredSubscriptionTable";

const ExpiredSubscriptionList = () => {
    return (
        <Fragment>
            <ExpiredSubscriptionTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />
        </Fragment>
    )
}

export default ExpiredSubscriptionList